import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "../contexts/AuthContext";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/Login";
import Layout from "../pages/Layout";
import IndexPais from "../pages/pais";
import IndexEstado from "../pages/estado";
import IndexMunicipio from "../pages/municipio";
import IndexCondutor from "../pages/condutor";
import FormCondutor from "../pages/condutor/form";
import IndexManifesto from "../pages/manifesto";
import IndexProfile from "../pages/profile";
import FormProfile from "../pages/profile/form";
import IndexUser from "../pages/user";
import FormUser from "../pages/user/form";
import IndexPermission from "../pages/permission";
import IndexEmpresa from "../pages/empresa";
import FormEmpresa from "../pages/empresa/form";
import RegisterForm from "../pages/register/form";
import FormManifesto from "../pages/manifesto/principal/form";
import FormConfig from "../pages/config/form";
import { NavigationProvider } from "../contexts/NavigationContext";
import AssinaturaQrcode from "../pages/assinatura/qrcode";
import IndexAssinatura from "../pages/assinatura";
import FormAssinatura from "../pages/assinatura/form";
import IndexLicenca from "../pages/licenca";
import FormLicenca from "../pages/licenca/form";
import { ForgotPasswordForm } from "../pages/login/ForgotPasswordForm";
import { ResetPassword } from "../pages/login/ResetPassword";
import Dashboard from "../pages/Dashboard";
import Home from "../pages/Home";
import Planos from "../pages/Planos";
import { Recursos } from "../pages/Recursos";
import ContatoPage from "../pages/Contatos";
import { IndexDevolucao } from "../pages/devolucao";
import { IndexCliente } from "../pages/cliente";
import { IndexRota } from "../pages/rota";
import { FormRota } from "../pages/rota/form";
import FormAtivacaoLicenca from "../pages/licenca/ativacao";

const Rotas = () => {

    return (
        <Router>
            <NavigationProvider>
                <AuthProvider>
                    <Routes>

                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<RegisterForm />} />
                        <Route path="/forgot-password" element={<ForgotPasswordForm />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
                        <Route path="/pais" element={<Layout><IndexPais /></Layout>} />
                        <Route path="/estado" element={<Layout><IndexEstado /></Layout>} />
                        <Route path="/municipio" element={<Layout><IndexMunicipio /></Layout>} />
                        <Route path="/condutor" element={<Layout><IndexCondutor /></Layout>} />
                        <Route path="/condutor/create" element={<Layout><FormCondutor /></Layout>} />
                        <Route path="/condutor/:id" element={<Layout><FormCondutor /></Layout>} />
                        <Route path="/manifesto" element={<Layout><IndexManifesto /></Layout>} />
                        <Route path="/profile" element={<Layout><IndexProfile /></Layout>} />
                        <Route path="/profile/create" element={<Layout><FormProfile /></Layout>} />
                        <Route path="/profile/:id" element={<Layout><FormProfile /></Layout>} />
                        <Route path="/user" element={<Layout><IndexUser /></Layout>} />
                        <Route path="/user/create" element={<Layout><FormUser /></Layout>} />
                        <Route path="/user/:id" element={<Layout><FormUser /></Layout>} />
                        <Route path="/empresa" element={<Layout><IndexEmpresa /></Layout>} />
                        <Route path="/empresa/create" element={<Layout><FormEmpresa /></Layout>} />
                        <Route path="/empresa/:id" element={<Layout><FormEmpresa /></Layout>} />
                        <Route path="/permission" element={<Layout><IndexPermission /></Layout>} />
                        <Route path="/licenca" element={<Layout><IndexLicenca /></Layout>} />
                        <Route path="/licenca/create" element={<FormLicenca />} />
                        <Route path="/licenca/ativacao/:id" element={<Layout><FormAtivacaoLicenca /></Layout>} />
                        <Route path="/assinatura" element={<Layout><IndexAssinatura /></Layout>} />
                        <Route path="/assinatura/create" element={<FormAssinatura />} />
                        <Route path="/manifesto/create" element={<Layout><FormManifesto /></Layout>} />
                        <Route path="/manifesto/:id" element={<Layout><FormManifesto /></Layout>} />
                        <Route path="/configs" element={<Layout><FormConfig /></Layout>} />
                        <Route path="/devolucoes" element={<Layout><IndexDevolucao /></Layout>} />
                        <Route path="/cliente" element={<Layout><IndexCliente /></Layout>} />
                        <Route path="/rota" element={<Layout><IndexRota /></Layout>} />
                        <Route path="/rota/create" element={<Layout><FormRota /></Layout>} />
                        <Route path="/rota/:id" element={<Layout><FormRota /></Layout>} />
                        <Route path="/qrcode" element={<AssinaturaQrcode />} />
                        <Route path="/planos" element={<Home><Planos /></Home>} />
                        <Route path="/recursos" element={<Home><Recursos /></Home>} />
                        <Route path="/contato" element={<Home><ContatoPage /></Home>} />


                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </AuthProvider>
            </NavigationProvider>
        </Router>

    );
}

export default Rotas;